import React from "react"

import WebinarForm, { WebinarFormProps } from "../../zohoForms/WebinarForm"
import { checkLinkUrl } from "../contentEdit"
import { ctaTarget } from "../../types"

type StickyFormProps = {
  formSource: string
  thankYouPage: ctaTarget
  reusableForm: WebinarFormProps
}

const StickyForm = ({
  formSource,
  thankYouPage,
  reusableForm,
}: StickyFormProps) => {
  return (
    <section className="c-stickyForm">
      <div className="container h-100">
        <div className="row justify-content-end h-100">
          <div className="col-lg-6 col-xxl-5 h-100">
            <div className="c-stickyForm__content">
              {reusableForm && (
                <WebinarForm
                  {...reusableForm}
                  formSource={formSource}
                  successRedirectUrl={checkLinkUrl(thankYouPage.cached_url)}
                />
              )}
            </div>
          </div>

          <div className="col-xxl-1" />
        </div>
      </div>
    </section>
  )
}

export default StickyForm
